import { render, staticRenderFns } from "./TableCell.vue?vue&type=template&id=5ce36a0b"
import script from "./TableCell.vue?vue&type=script&lang=ts"
export * from "./TableCell.vue?vue&type=script&lang=ts"
import style0 from "./TableCell.vue?vue&type=style&index=0&id=5ce36a0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports